import { useState } from 'react';
import { entBig, entSmalls } from '@/mocks/homeContent';

const filters = ['全部', '舞台现场', '晚会后台', '舆论拆解'];

export default function EntBlacklist() {
  const [active, setActive] = useState('全部');
  return (
    <section id="娱乐黑料" className="bg-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-vip-crown-2-line flex h-5 w-5 items-center justify-center" />
              </span>
              <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">娱乐黑料</h2>
              <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-bold text-accent-900">圈内动向</span>
            </div>
            <p className="mt-2 text-sm text-foreground-600">舞台、后台与舆论，把娱乐圈的每一次「翻车现场」讲明白</p>
          </div>
          {/* segmented filter */}
          <div className="flex rounded-full bg-background-200 p-1">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-bold transition ${
                  active === f ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid gap-4 lg:grid-cols-3">
          {/* big feature */}
          <a href="#专题话题" className="group relative col-span-1 overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-200 lg:col-span-2">
            <div className="relative h-56 w-full overflow-hidden sm:h-64 lg:h-[420px]">
              <img src={entBig.img} alt="综艺剧本感争议事件全貌主稿" title="娱乐黑料 综艺剧本感争议主稿" className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/25 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-sm bg-accent-500 px-2 py-0.5 font-label text-xs tracking-wide text-foreground-950">{entBig.cat}</span>
                  <span className="text-xs text-background-100">阅读 {entBig.views} · 赞 {entBig.likes} · 评论 {entBig.comments}</span>
                </div>
                <h3 className="mt-2 font-heading text-xl font-black leading-snug text-background-50 transition group-hover:text-accent-200 md:text-3xl">
                  {entBig.title}
                </h3>
                <p className="mt-2 line-clamp-2 hidden max-w-2xl text-sm leading-6 text-background-200/90 sm:block">{entBig.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-bold text-accent-300">
                  看事件全貌 <i className="ri-arrow-right-line flex h-4 w-4 items-center justify-center" />
                </span>
              </div>
            </div>
          </a>

          {/* small stack */}
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-1">
            {entSmalls.map((s, i) => (
              <a key={i} href="#专题话题" className="group flex gap-3 rounded-xl bg-background-50 p-2.5 ring-1 ring-background-200 transition hover:ring-primary-300">
                <div className="relative h-20 w-24 shrink-0 overflow-hidden rounded-lg sm:h-20 sm:w-28">
                  <img src={s.img} alt={s.title} title={`娱乐黑料 ${s.title}`} className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105" />
                </div>
                <div className="min-w-0 flex-1">
                  <h4 className="line-clamp-2 text-sm font-bold leading-5 text-foreground-900 transition group-hover:text-primary-700">{s.title}</h4>
                  <div className="mt-2 flex items-center justify-between gap-2">
                    <span className="whitespace-nowrap rounded-sm bg-secondary-100 px-1.5 py-0.5 text-[10px] font-bold text-secondary-900">{s.tag}</span>
                    <span className="whitespace-nowrap text-[11px] text-foreground-500">{s.views} 阅读</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}